import React from "react";
import DashBoard from "./Components/index";
import { fromDaily, toDaily } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const auth = useAuth();
  const activeMediaGroup = auth.state.activeMediaGroup;
  const fromDate = fromDaily(queryString.parse(props.location.search).date);
  const toDate = toDaily(queryString.parse(props.location.search).date);
  const queryType =queryString.parse(props.location.search).type;

  const onClickLineChart = (date, type = null) => {
    props.history.push(`/media/dashboard/hourly?activeMediaGroup=${activeMediaGroup}&date=${date}&type=${type}`);
  };
  const onClickListButton = (date, type = null) => {
    props.history.push(`/media/dashboard/details?activeMediaGroup=${activeMediaGroup}&date=${date}&interval=daily&type=${type}`);
  };
  const handleChangeDateSingle = (date, type = null) => {
    props.history.push(`/media/dashboard/daily?activeMediaGroup=${activeMediaGroup}&date=${date}&type=${type}`);
  };

  return (
    <DashBoard
      fromDate={fromDate}
      toDate={toDate}
      unit="hour"
      target="daily"
      type={queryType}
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
      handleChangeDateSingle={handleChangeDateSingle}
    />
  );
}

export default withRouter(Page);
